var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.openUpgrade()}}},[_vm._v("\n  Upgrade now\n")])}
var staticRenderFns = []

export { render, staticRenderFns }